// ============================================================
// web/src/features/devis/PlanEtFiche.jsx — LE DESSIN, ET TOUT CE QUI SE
// LIT DESSUS.
// ------------------------------------------------------------
// À gauche le plan ; à droite, empilés : l'identité de la pièce puis la
// matière et le brut. Les trois viennent de la même chose — la LECTURE du
// plan — et ils se regardent ensemble.
//
// ── POURQUOI LA MATIÈRE EST MONTÉE ICI — 16 septembre 2026 ──
//
// Mesuré sur le devis 2026-09-040, à 1 920 px : la fiche faisait 442 px de
// haut contre 928 px pour le dessin (486 px de vide dessous), et la
// colonne de droite du chiffrage 742 px contre 2 880 px à gauche
// (2 100 px de vide). Trois mises en page ont été rendues et mesurées
// dans un vrai navigateur avant de trancher : celle-ci supprime les deux
// vides et fait passer la page de 6 114 à 4 991 px de haut.
//
// Elle DIT aussi ce que le bloc est : nuance, densité, prix au kilo et
// forme du brut viennent de la lecture et du référentiel, pas d'une
// décision du deviseur (correction du 21 août).
// ============================================================
import PlanViewer from './PlanViewer.jsx';
import FichePiece from './FichePiece.jsx';
import LecturePlanMatiere from './LecturePlanMatiere.jsx';

export function PlanEtFiche({
  devisId, devis, pages, pageId, onSelectPage,
  piece, result, sources, materiaux, disabled, onChange, onRecharger, decoupe = null,
}) {
  const avecPlan = (pages ?? []).length > 0;
  return (
    <div className={avecPlan ? 'plan-et-fiche' : 'plan-et-fiche fiche-seule'}>
      {avecPlan ? (
        <PlanViewer
          devisId={devisId}
          pages={pages}
          pageId={pageId}
          // Aucune référence tant qu'aucune pièce n'est sélectionnée : le
          // visualiseur ne titre jamais une page du nom d'une pièce qui
          // n'est pas la sienne (invariant 13).
          reference={piece ? piece.ref : null}
          onSelectPage={onSelectPage}
          decoupe={disabled ? null : decoupe}
        />
      ) : null}
      {piece ? (
        <div className="plan-et-fiche__droite">
          {/* Le nom du client vient du DEVIS : le chercher dans une liste
              bornée à 100 laissait « Client — » sur toute société classée
              au-delà de la centième. */}
          <FichePiece
            devis={devis}
            client={{ company: devis.client_company }}
            piece={piece}
            disabled={disabled}
            onChange={onChange}
          />
          {piece.is_purchase ? null : (
            <LecturePlanMatiere
              piece={piece}
              result={result}
              disabled={disabled}
              onChange={onChange}
              sources={sources}
              materiaux={materiaux}
              onRecharger={onRecharger}
            />
          )}
        </div>
      ) : null}
    </div>
  );
}

export default PlanEtFiche;
